export default __webpack_public_path__ + "static/media/Body-Grotesque-Fit-Bold-Italic.e95dd4d3.ttf";